import React from 'react';
import 'twin.macro';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { useNavigate } from 'react-router-dom';
import useCopyEDT from '@teetsh/app/src/queries/edt/useCopyEDT';
import { UserLocale } from '@teetsh/app/src/types/user';
import { ClassroomMapping } from '@teetsh/app/src/components/EntitiesSelectorModals/ClassroomsMappingModal/ClassroomsMapping';
import { ClassroomsMappingModal } from '@teetsh/app/src/components/EntitiesSelectorModals/ClassroomsMappingModal';

interface Props {
  edtId?: string;
  onClose: () => void;
  locale: UserLocale;
}

export function CopyEDTModal(props: Props) {
  const { edtId, onClose, locale } = props;

  const { school, schoolyear } = useSchoolSchoolyear();
  const srcClassrooms = useClassrooms();
  const navigate = useNavigate();
  const copyEDT = useCopyEDT();

  const onSubmit = ({
    schoolyearId: newSchoolyearId,
    schoolId: newSchoolId,
    classroomsMapping,
  }: {
    schoolyearId: string;
    schoolId: string;
    classroomsMapping: ClassroomMapping[];
  }) => {
    if (classroomsMapping.length === 0 || !edtId) {
      return Promise.resolve();
    }

    return copyEDT({
      srcSchoolyearId: schoolyear.id,
      srcSchoolId: school.id,
      destSchoolyearId: newSchoolyearId,
      destSchoolId: newSchoolId,
      mappings: classroomsMapping,
      edtId,
    }).then(() => {
      navigate(
        `/annee-scolaire/${newSchoolyearId}/ecole/${newSchoolId}/emploi-du-temps`,
      );
    });
  };

  return (
    <ClassroomsMappingModal
      isOpen={!!edtId}
      srcClassrooms={srcClassrooms}
      locale={locale}
      onClose={onClose}
      onSubmit={onSubmit}
      enableCreateClassroom
      enableDateStep={false}
    />
  );
}
